import LearnerSocialMediaContainer from './LearnerSocialMediaPageContainer';

export default LearnerSocialMediaContainer;
